/**
 * @fileOverview 权限
 * @author lixiaobin
 */

export default {

    install(Vue) {
        Vue.prototype.$selfConfirm = function(text, type='info', title = '提示') {
            let alterPromise = new Promise((resolve, reject)=>{
                this.$confirm(text, title , {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type,
                callback: action => {
                  if(action == 'confirm') {
                    resolve(action)
                  } else {
                    reject(action)
                  }
                }
              });
            })
            return alterPromise
        }
        Vue.prototype.$selfAlter = function(text, type='info', title = '提示') {
            let alterPromise = new Promise((resolve, reject)=>{
              this.$alert(text, title , {
                confirmButtonText: '确定',
                type,
                callback: action => {
                  if(action == 'confirm') {
                    resolve(action)
                  } else {
                    reject(action)
                  }
                }
              });
            })
            return alterPromise
        }
        Vue.prototype.$filterMoney = function (val) {
            val += '';
            val = val.replace(/[^\d\.]/g, '');
            let index = val.indexOf('.')
            let lastIndex = val.lastIndexOf('.')
            if (index > -1 && index !== lastIndex) {
                let str = val.slice(0, index + 1)
                for (let cStr of val.slice(index + 1)) {
                    if (cStr !== '.') {
                        str += cStr
                    }
                }
                return str
            }
            return val
        }
        Vue.prototype.$copyCode = function(code) {
          const element = document.createElement('input')
          element.setAttribute('id', 'copyCodeInput')
          document.body.appendChild(element)
          element.value = `流程编号：${code}`
          element.select()
          document.execCommand("copy");
          this.$message.success('流程编号已复制')
          setTimeout(() => {
              document.body.removeChild(element)
          })
      }
    }
}
